import * as React from 'react';
import Svg, {
  SvgProps,
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={380}
    height={87}
    viewBox={'0 0 380 87'}
    {...props}
    fill={'none'}
    stroke={'none'}>
    <G clipPath="url(#a)">
      <Path
        fill="url(#b)"
        fillOpacity={0.9}
        fillRule="evenodd"
        d="M190 59c17.121 0 31-13.88 31-31 0-2.766-.362-5.448-1.042-8H346.5c18.502 0 33.5 14.998 33.5 33.5 0 18.501-14.998 33.5-33.5 33.5h-313C14.998 87 0 72.001 0 53.5 0 34.998 14.998 20 33.5 20h126.542A31.034 31.034 0 0 0 159 28c0 17.12 13.879 31 31 31Z"
        clipRule="evenodd"
      />
      <Path
        fill="#fff"
        d="M190 56c15.464 0 28-12.536 28-28S205.464 0 190 0s-28 12.536-28 28 12.536 28 28 28Z"
      />
    </G>
    <Defs>
      <LinearGradient
        id="b"
        x1={177.186}
        x2={177.186}
        y1={20}
        y2={87}
        gradientUnits="userSpaceOnUse">
        <Stop stopColor="#009F9C" />
        <Stop offset={1} stopColor="#007BB2" />
      </LinearGradient>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h380v87H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SvgComponent;
